// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__bct2L","rotating":"Spinner_rotating__azDh6"};